module.exports = __webpack_public_path__ + "img/主营业务_软件产品中心08.808f203d.png";